export enum TextTrackKind {
    Captions = 'captions',
    Chapters = 'chapters',
    Thumbnails = 'thumbnails',
    Description = 'description',
    Metadata = 'metadata'
}
